import { render, staticRenderFns } from "./PlacementsListItem.vue?vue&type=template&id=5615deaa&"
import script from "./PlacementsListItem.vue?vue&type=script&lang=js&"
export * from "./PlacementsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports